{
  "primaryEmailAddress": "Primary Email Address",
  "mobileNumber": "Mobile Number",
  "status": "Status",
  "comment": "Comment",
  "invalidCSV": "Please select the CSV file only.",
  "invalidMobile": "Mobile number is not valid",
  "userNotFound": "User Not Found",
  "invalidCSVHeader":"CSV header is invalid. Please check the CSV file again.",
  "notAClientUser": "Not a Client User",
  "phoneNumberPopupInformationText": "User list edits uploaded. Click Save Changes button on the main interface to save the user list update."
}